import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import { connect } from "react-redux";
import firebase from "firebase";

import MdCadastro from "../modalCadastro";
import MdRsenha from "../modalRecuperarSenha";
import { FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap";
import { Email, Senha, Login } from "../../redux/actions/login";
function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <div>{help}</div>}
    </FormGroup>
  );
}
class login extends Component {
  componentWillMount() {
    var config = {
      apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
      authDomain: "tourbrazil-41fbe.firebaseapp.com",
      databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
      projectId: "tourbrazil-41fbe",
      storageBucket: "tourbrazil-41fbe.appspot.com",
      messagingSenderId: "927605208400"
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
  }
  render() {
    return (
      <div className={css(styles.formContainer)}>
        <FieldGroup
          id="formControlsEmail"
          type="email"
          label="Email"
          placeholder="Digite seu E-mail"
          onChange={this.props.Email}
          value={this.props.email}
        />
        <FieldGroup
          id="formControlsPassword"
          label="Senha"
          type="password"
          placeholder="Digite sua Senha"
          onChange={this.props.Senha}
          value={this.props.senha}
        />
        <div className="text-center">
          <Button
            bsStyle="success"
            className="btn btn-default btn-block"
            type="submit"
            onClick={() => this.props.Login(this.props.email, this.props.senha)}
          >
            Entrar
          </Button>
        </div>
        <div className={css(styles.divlogin)} />
        <div>
          <h4 className="text-center">{this.props.loginState}</h4>
        </div>
        <MdCadastro />
        <MdRsenha />
      </div>
    );
  }
}
const translateKeyframes = {
  "0%": {
    transform: "translateX(-50px)"
  },

  "100%": {
    transform: "translateX(0px)"
  }
};

const opacityKeyframes = {
  from: {
    opacity: 0
  },

  to: {
    opacity: 1
  }
};
const styles = StyleSheet.create({
  formContainer: {
    animationName: [translateKeyframes, opacityKeyframes],
    animationDuration: "2s, 1200ms",
    animationIterationCount: "1",
    width: "70%"
  },
  divlogin: {
    marginBottom: "20px"
  }
});

const mapStateToProps = state => {
  return {
    email: state.login.email,
    senha: state.login.senha,
    loginState: state.login.loginState
  };
};
export default connect(
  mapStateToProps,
  { Email, Senha, Login }
)(login);



// WEBPACK FOOTER //
// ./src/assets/formLogin/index.js